import type { ExpenseCategory, ExpenseFormData, LineItem } from '@/lib/types';

export interface ParsedReceipt {
  store_name: string;
  transaction_date: string;
  items: LineItem[];
  subtotal: number;
  discount: number;
  tax: number;
  total: number;
}

export function normalizeParsedReceipt(raw: Partial<ParsedReceipt>): ExpenseFormData {
  const items = (raw.items || []).map((item) => ({
    name: item.name || 'Unknown item',
    quantity: Math.max(1, Number(item.quantity) || 1),
    unit_price: Math.max(0, Number(item.unit_price) || 0),
    total: Math.max(0, Number(item.total) || 0),
    category: (item.category || 'other') as ExpenseCategory,
  }));

  const subtotal = Number(raw.subtotal) || 0;
  const discount = Math.max(0, Number(raw.discount) || 0);
  const tax = Number(raw.tax) || 0;
  const total = Number(raw.total) || subtotal - discount + tax;

  return {
    transaction_date: raw.transaction_date || new Date().toISOString(),
    store_name: raw.store_name || '',
    items,
    subtotal,
    discount,
    tax,
    total,
    status: 'pending',
    notes: '',
  };
}
